import { render, staticRenderFns } from "./GroupsListing.vue?vue&type=template&id=2c4870d4&scoped=true&"
import script from "./GroupsListing.vue?vue&type=script&lang=js&"
export * from "./GroupsListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4870d4",
  null
  
)

export default component.exports